import { observer } from 'mobx-react-lite'
import { Tooltip } from 'shared/ui'
import { type ISwitchActionProps, SwitchAction } from 'shared/ui/SwitchAction'
import { type ITrigger } from 'entities/Trigger/model/Trigger'
import { triggerActionsStore } from 'widgets/TriggerActions/getTriggerActions'

type Props = {
  item: ITrigger
  size?: ISwitchActionProps['size']
  className?: string
}

export const TriggerActiveToggle = observer(({ item, size = 'small', className }: Props) => (
  <div className={className}>
    <Tooltip label={item.isInvalid && 'Suspicious content detected'} placement={'top'}>
      <SwitchAction
        size={size}
        active={item.status === 'active'}
        disabled={item.isInvalid}
        onTrigger={async () => {
          await triggerActionsStore.updateStatus(item)
        }}
        ariaLabel={`TriggerActiveToggle-${item.id}`}
      />
    </Tooltip>
  </div>
))
